<template>

    <div id="editar_pedido_panel" class="order">
        <div class="top_banner">
            <h3>NÚMERO DE PEDIDO: {{order.numero_pedido}} - SEMANA {{order.semana}} <span style="font-weight: 500;font-size: 13px;">{{ yearWeek | subtitleEnvio }}</span></h3>
        </div>
        <div class="products_order_block row mt-3">

            <div class="col-12 head title">
                <img src="/img/iconos/icon_variedad.svg" alt="icon_variedad.svg">
                <h3>Artículos</h3>
            </div>

            <table class="gestionar_orders_block">
                <div>
                    <pedido-line-edit @updateLine="updateLine" v-for="(line, index) in orderData.lineas" :line="line" :key="index"></pedido-line-edit>
                </div>
                <div>
                    <pedido-line-medida-edit @updateLine="updateLineMedida" v-for="(line, index) in orderData.lineas_medida" :bloqueado="!!order.blocked_at" :line="line" :key="index"></pedido-line-medida-edit>
                </div>
            </table>
            <div v-b-modal.modal-porducto_disponible class="col-12 addNewItem cursor_pointer" v-if="addWeek <= 4 && addWeek > 0">
                <i class="fa fa-plus-circle"></i>
            </div>
            <modal-block v-cloak ref="modalForProducts" title="Productos disponibles" desing="default" refer="porducto_disponible" size="xl">
                <div id="section_header">
                    <div class="links_left w-border" style="display: inline-flex; flex-wrap: wrap;">
                        <a v-if="tarifa_id!=1" :class="(filters.eco)?'item_link active':'item_link'">
                                <span @click="filters.eco=true" class="alt_eco">
                                    <img src="/img/iconos/icon_ecologico.svg" alt="icon_ecologico.svg" class="icon">
                                    Ecológico
                                    <span class="checkbox"></span>
                                </span>
                            <img v-b-modal.modal-eco src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                            <modal-block v-cloak title="Ecológico" :href="route('help.details','ecologica')" desing="ecologico" refer="eco">
                                Plantas con certificado ecológico producidas bajo
                                la normativa de producción ecológica UE 834/2007.
                            </modal-block>
                        </a>
                        <a :class="(!filters.eco)?'item_link active':'item_link'">
                                <span @click="filters.eco=false" class="alt_residuocero">
                                    Residuo cero
                                    <span class="checkbox"></span>
                                </span>
                            <img v-b-modal.modal-residuocero src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
                            <modal-block v-cloak title="Residuo cero" :href="route('help.details','residuo-cero')" desing="residuocero" refer="residuocero">
                                Planta para producción convencional cultivada con productos químicos de bajo impacto.
                            </modal-block>
                        </a>
                    </div>
                </div>
                <pedido-edit-add-item @addLineToOrder="addLineToOrder" :add-week="addWeek" :filters="filters" :lineas="orderData.lineas"></pedido-edit-add-item>
            </modal-block>
        </div>
        <div class="info_data_order_block row mt-3">
            <pedido-shipping :share-ship="orderData.share_ship_pedido_id" :metodoEnvio="orderData.transportista_id" :direcciones="direcciones" :direccionEnvio="orderData.direccion_envio" :direccionFacturacion="orderData.direccion_facturacion" :unidades-data="unidadesData"></pedido-shipping>
        </div>
        <div class="total_block row">

            <div class="offset-md-6 col-md-6">
                <div class="total">
                    <span>Subtotal</span>
                    <span>{{formatMoney(orderData.subtotal)}}</span>
                </div>
                <div v-if="orderData.ahorro>0" class="total">
                    <span>Ahorro</span>
                    <span>-{{formatMoney(orderData.ahorro)}}</span>
                </div>
                <div class="total">
                    <span>Envio</span>
                    <span v-if="orderData.importe_envio>0" >{{formatMoney((orderData.importe_envio*100)/110)}}</span>
                    <span v-else>GRATIS</span>
                </div>
                <div class="total">
                    <span>BASE IMPONIBLE</span>
                    <span>{{formatMoney(orderData.base_imponible)}}</span>
                </div>
                <div class="total">
                    <span>IVA</span>
                    <span>{{formatMoney(orderData.iva)}}</span>
                </div>
                <div v-if="orderData.recargo_equivalencia>0" class="total">
                    <span>Recargo de equivalencia</span>
                    <span>{{formatMoney(orderData.recargo_equivalencia)}}</span>
                </div>
                <div class="total">
                    <span>TOTAL PEDIDO (IVA incluido)</span>
                    <span>{{formatMoney(orderData.precio_total)}}</span>
                </div>
            </div>

            <form id="go_update" :action="route('account.pedidos.update')" method="POST">
                <input type="hidden" name="_token" :value="formToken.content">
                <input type="hidden" name="orderData" :value="JSON.stringify(orderData)">
            </form>

            <div class="offset-md-6 col-md-6 content_button_next">
                <a class="button_cart_style_alt" onclick="event.preventDefault();document.getElementById('go_update').submit();">
                    <div style="text-align: center;">
                        <span>Guardar cambios en el pedido</span>
                    </div>
                </a>
            </div>

        </div>
    </div>

</template>

<script>
    import lodash from "lodash";
    export default {
        props: ['order','tarifa_id'],
        data() {
            return {
                direcciones: '',
                orderData: lodash.cloneDeep(this.order),
                addWeek: '',
                filters: {
                    'ordenar': [],
                    'especie': [],
                    'mote': [],
                    'zona': [],
                    'formato': [],
                    'eco': (this.tarifa_id==1)?false:true,
                    'oferta': false,
                    'buscarCadena': '',
                },
                formToken:''
            }
        },
        computed: {
            unidadesData() {
                return this.orderData.lineas.concat(this.orderData.lineas_medida).reduce((a, b) => a + b.unidades, 0);
            },
            yearWeek() {
                return this.orderData.anyo + '-' + this.orderData.semana;
            }
        },
        mounted: function () {
            console.log(`this.orderData`, this.orderData)
            this.loadAddressClient();
            this.loadWeekInfo();

            this.formToken = document.head.querySelector('meta[name="csrf-token"]');

            if (this.tarifa_id==1) {
                this.filters.eco=false;
            }
        },
        methods: {
            loadAddressClient: function () {
                axios.get('/account/direccion/get-address').then(response => {
                    this.direcciones = response.data.addresses;
                }).catch(e => {
                    console.log(e);
                });
            },
            loadWeekInfo: function () {
                axios.post(this.route('account.getWeekInfo'),{
                    week: this.orderData.semana,
                    year: this.orderData.anyo
                }).then(response => {
                    this.addWeek = response.data.week;
                }).catch(e => {
                    console.log(e);
                });
            },
            updateLine: function (lineData, index) {
                this.orderData.lineas[index] = lineData;
                this.updateTotals();
            },
            updateLineMedida: function (lineData, index) {
                this.orderData.lineas_medida[index] = lineData;
                this.updateTotals();
            },
            updateTotals: function () {
                this.orderData.subtotal = Math.round(((this.orderData.lineas.reduce((a, b) => a + parseFloat(b.importe), 0) + this.orderData.lineas_medida.reduce((a, b) => a + parseFloat(b.importe), 0)) * 100 / 110 || 0) * 100) / 100;
                this.orderData.ahorro = this.orderData.lineas.reduce((a, b) => a + parseFloat(b.ahorro), 0) + this.orderData.lineas_medida.reduce((a, b) => a + parseFloat(b.ahorro), 0) || 0;
                this.orderData.base_imponible = (this.orderData.subtotal - this.orderData.ahorro) + Math.round(((this.orderData.importe_envio * 100 / 110) || 0) * 100) / 100;
                this.orderData.iva = this.orderData.lineas.reduce((a, b) => a + parseFloat(b.total), 0) + this.orderData.lineas_medida.reduce((a, b) => a + parseFloat(b.total), 0) + parseFloat(this.orderData.importe_envio) - this.orderData.base_imponible || 0;
                this.orderData.recargo_equivalencia = (this.orderData.direccion_facturacion.requiere_re) ? this.orderData.base_imponible * 0.014 : 0;
                this.orderData.precio_total = this.orderData.base_imponible + this.orderData.iva + this.orderData.recargo_equivalencia || 0;
            },
            addLineToOrder: function (line) {
                this.$refs.modalForProducts.$refs.porducto_disponible.hide();

                line.pedido_id = this.orderData.id;
                this.orderData.lineas.push(line);
                this.updateTotals();
            }
        },
    }
</script>
